import type { Renderer } from './types.ts';
import { WebGL2Renderer, type WebGL2RendererOptions } from './webgl2/WebGL2Renderer.ts';

export type RendererOptions = WebGL2RendererOptions;

/** Creates the best available renderer for this browser (WebGL2 today; WebGPU later). */
export function createRenderer(canvas: HTMLCanvasElement, opts: RendererOptions = {}): Renderer {
  return new WebGL2Renderer(canvas, opts);
}
